// 所有 embed 使用 modestbranding=1 减小 YouTube 角标/品牌显示
export default {
  hk: `jefeAr_g-Ug`,
  en: `HUEv6PAsSy0`,
  vi: `dQz179MqG_0`,
  th: `eWGTzqdx_AI`,
  id: `bacb9BcciZs`,
}